<template>
  <div :class="$style.container">
    <template v-if="href">
      <a :class="$style.item" :href="href">
        <i :class="$style.icon" class="fas fa-chevron-left" />
        {{ label }}
      </a>
    </template>

    <template v-else-if="to">
      <router-link :class="$style.item" :to="to">
        <i :class="$style.icon" class="fas fa-chevron-left" />
        {{ label }}
      </router-link>
    </template>

    <template v-else>
      <a :class="$style.item" @click="$emit('click')">
        <i :class="$style.icon" class="fas fa-chevron-left" />
        {{ label }}
      </a>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'NavPrev',
  props: {
    label: {
      type: String,
    },
    href: {
      type: String,
    },
    to: {
      type: [String, Object],
    },
  },
});
</script>

<style lang="scss" module>
.item {
  @include font(16, medium, label);
  display: inline-block;
  margin-bottom: 3px;

  .icon {
    transition: 0.1s;
    margin: 0 5px;
  }

  &:hover .icon {
    transform: translateX(-5px);
  }
}
</style>
